/** Match UserHome credibility city list. */
export const PERFORMANCE_CITIES = [
  'Mumbai',
  'Delhi',
  'Bengaluru',
  'Hyderabad',
  'Chennai',
  'Kolkata',
  'Pune',
  'Ahmedabad',
  'Jaipur',
  'Goa',
  'Noida',
  'Gurgaon',
  'Chandigarh',
] as const;

export const isPerformanceCityInList = (loc: string): boolean =>
  PERFORMANCE_CITIES.some((city) => city.toLowerCase() === loc.trim().toLowerCase());

export const normalizePerformanceLocationPrefill = (
  where: string | null | undefined
): string | null => {
  const trimmed = where?.trim() ?? '';
  if (!trimmed) return null;
  const match = PERFORMANCE_CITIES.find(
    (city) => city.toLowerCase() === trimmed.toLowerCase()
  );
  return match ?? null;
};
